<h1 i18n>Forgotten your password?</h1>

<p i18n>
    Enter your email address in the form below. You will receive an email with
    instructions to reset your password.
</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div>
        <label for="email" class="form-label" i18n>Email address</label>
        <input
            id="email"
            type="email"
            class="form-control"
            [class.is-invalid]="
                form.controls.email.touched && form.controls.email.invalid
            "
            [formControl]="form.controls.email"
        />
        @for (error of emailErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <button type="submit" class="btn btn-primary my-3">
        <span i18n>Submit</span>
        @if (loading$ | async) {
        <div class="spinner-border spinner-border-sm ms-1" role="status">
            <span class="visually-hidden" i18n>
                Requesting password reset link...
            </span>
        </div>
        }
    </button>
</form>
